/*
 * Copyright (c) 2019 - Convergence Labs, Inc.
 *
 * This file is part of the Convergence Server, which is released under
 * the terms of the GNU General Public License version 3 (GPLv3). A copy
 * of the GPLv3 should have been provided along with this file, typically
 * located in the "LICENSE" file, which is part of this source code package.
 * Alternatively, see <https://www.gnu.org/licenses/gpl-3.0.html> for the
 * full text of the GPLv3 license, if it was not provided.
 */

import {ObjectPropertyValidator} from "./ObjectPropertyValidator";
import {ArrayIndexValidator} from "./ArrayIndexValidator";
import {ContainerNode} from "../model/ContainerNode";
import {ObjectNode} from "../model/ObjectNode";
import {ArrayNode} from "../model/ArrayNode";

export type PropertyValidationStatus = "ok" | "warning" | "error";

export interface PropertyValidation {
  status: PropertyValidationStatus;
  message?: string;
}

export const OK_PROPERTY_VALIDATION: PropertyValidation = {status: "ok"};

export class PropertyValidator {
  public static validate(node: ContainerNode<any>, newProperty: string): PropertyValidation {
    if (node instanceof ObjectNode) {
      return ObjectPropertyValidator.validate(node, newProperty);
    } else if (node instanceof ArrayNode) {
      return ArrayIndexValidator.validate(node, newProperty);
    } else {
      throw new Error("Unknown node type: " + node.type());
    }
  }
}
